// src/components/WithPlanCheck.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const WithPlanCheck = (WrappedComponent) => {
  return function WithPlanCheckComponent(props) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const checkPlanStatus = async () => {
        try {
          // Make API call to check plan status
          const { data } = await axios.get('/api/check-plan-status');
          
          if (data.planExceeded) {
            navigate('/app/upgrade-plan');
          }
        } catch (error) {
          console.error('Error checking plan status:', error);
        } finally {
          setIsLoading(false);
        }
      };

      checkPlanStatus();
    }, [navigate]);

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return <WrappedComponent {...props} />;
  };
};

export default WithPlanCheck;